import { useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import ConsentimientoTeleSalud from "../autoagendamiento/ConsentimientoTeleSalud";
import SignatureCanvas from "react-signature-canvas";
import { useRef } from "react";
import Select from "react-select";
import { getLengthDN, getTipoDocumento } from "../autoagendamientov2/colombia/ClbForm";
import { useEffect } from "react";
import Get from "../../api/Get";
import { PARTNER_GET_ACTIVE_SIN_TOKEN, TIPO_DOCUMENTO_PACIENTE_COLOMBIA } from "../../api/Routes";
import { getIpPublic } from "../../utils/getIpPublic";
import Loading from "../autoagendamientov2/Loading";

function PendiengLegalWarningV2({
    t, 
    items, 
    setItems,
    onHandleChangeLegalWarning,
    content,
    setContent
}){
    const sigCanvas = useRef({});
    const [acceptPatient, setAcceptPatient] = useState(false)
    const clear = () => sigCanvas.current.clear();
    const [dataAcudiente, setDataAcudiente] = useState({
        tipoDocumentoOpt: [],
        identityDocumentType: '',
        documentNumber: '',
        fullName: '',
        tipoPacienteOpt: [],
        patientRelationship: '',
        aceptacionAcudiente: false,
        hasLength: 10
    })

    const [errors, setErrors] = useState({
        firma: {
            error: false,
            text: ''
        },
        identityDocumentType: {
            error: false,
            text: ''
        },
        documentNumber: {
            error: false,
            text: ''
        },
        fullName: {
            error: false,
            text: ''
        },
        patientRelationship: {
            error: false,
            text: ''
        }
    });

    const checkValidationDocument = (value) => {
        if(getTipoDocumento(dataAcudiente.identityDocumentType, dataAcudiente.tipoDocumentoOpt)){
            setErrors(err=>({
                ...err,
                documentNumber: {
                    error: true,
                    text: 'Campo requerido'
                }
            }))
            //setAllowDoAppt(false)
        }else{
            if(value === ''){
                setErrors(err=>({
                    ...err,
                    documentNumber: {
                        error: true,
                        text: 'Campo requerido'
                    }
                }))
                //setAllowDoAppt(false)
            }
            else if(value.length < 5){
                setErrors(err=>({
                    ...err,
                    documentNumber: {
                        error: true,
                        text: 'Debe tener una longitud mínima de 5 caracteres'
                    }
                }))
                //setAllowDoAppt(false)
            }else if(value.length > dataAcudiente.hasLength){
                setErrors(err=>({
                    ...err,
                    documentNumber: {
                        error: true,
                        text: `Debe tener una longitud máxima de ${dataAcudiente.hasLength} caracteres`
                    }
                }))
                //setAllowDoAppt(false)
            }else{
                setErrors(err=>({
                    ...err,
                    documentNumber: {
                        error: false,
                        text: ''
                    }
                }))
                //setAllowDoAppt(true)
            }
        }
    }

    //servicios
    useEffect(() => {
        const fetchApi = async () => {
            try {
                const response = await Get({url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA, noToken: true});
                setDataAcudiente(prev=>({
                    ...prev,
                    tipoDocumentoOpt: response.data 
                }))
            } catch (error) {
                setDataAcudiente(prev=>({
                    ...prev,
                    tipoDocumentoOpt: [] 
                }))
            }
            try {
                const response = await Get({url: `${PARTNER_GET_ACTIVE_SIN_TOKEN}/${items.cita.patientDTO.account.id}`, noToken:  true})
                setDataAcudiente(prev=>({
                    ...prev,
                    tipoPacienteOpt: response.data.data.response 
                }))
            } catch (error) {
                setDataAcudiente(prev=>({
                    ...prev,
                    tipoPacienteOpt: []
                }))
            }
        }
        fetchApi();
    }, [])

    const changeLegalWarning = async (dataToSend) =>{  
        try {
            let doAppt = true;
            if(sigCanvas.current.isEmpty() || dataAcudiente.aceptacionAcudiente){
                const errorCopy = {...errors}
                if(sigCanvas.current.isEmpty()){
                    errorCopy.firma.error = true;
                    errorCopy.firma.text = 'Firma requerida'
                    doAppt = false;
                }else{
                    errorCopy.firma.error = false;
                    errorCopy.firma.text = ''
                }
                if(dataAcudiente.fullName === ''){
                    errorCopy.fullName.error = true;
                    errorCopy.fullName.text = 'Campo requerido';
                    doAppt = false;
                }else{
                    errorCopy.fullName.error = false;
                    errorCopy.fullName.text = ''
                }
                if(dataAcudiente.documentNumber === ''){
                    errorCopy.documentNumber.error = true;
                    errorCopy.documentNumber.text = 'Campo requerido';
                    doAppt = false;
                }else{
                    errorCopy.documentNumber.error = false;
                    errorCopy.documentNumber.text = ''
                }
                if(dataAcudiente.patientRelationship === ''){
                    errorCopy.patientRelationship.error = true;
                    errorCopy.patientRelationship.text = 'Campo requerido';
                    doAppt = false;
                }else{
                    errorCopy.patientRelationship.error = false;
                    errorCopy.patientRelationship.text = ''
                }
                if(dataAcudiente.identityDocumentType === ''){
                    errorCopy.identityDocumentType.error = true;
                    errorCopy.identityDocumentType.text = 'Campo requerido';
                    doAppt = false;
                }else{
                    errorCopy.identityDocumentType.error = false;
                    errorCopy.identityDocumentType.text = ''
                }
                setErrors(errorCopy)
            }
            if(doAppt){
                setItems(prev=>({
                    ...prev,
                    isProcessRequest: true
                }));
                const firma = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png")
                const base64result = firma.split(',')[1];
                const responseIp = await getIpPublic();
                let data = {
                    id: items.cita.id,
                    legalWarnings: [{
                        id: items.legalWarning.id,
                        acceptPatient: "approved",
                        ipAddress: responseIp,
                        legalWarningType: "InformedConsent",
                        dataRecord: content,
                        url_photo: base64result,
                        legalAgent: dataAcudiente.aceptacionAcudiente ? {
                            fullName: dataAcudiente.fullName,
                            documentNumber: dataAcudiente.documentNumber,
                            identityDocumentType: {
                                id: dataAcudiente.identityDocumentType
                            },
                            "patientRelationship": {
                                id: dataAcudiente.patientRelationship
                            }
                        }: null
                    }]
                }
                onHandleChangeLegalWarning(data)
            }
        } catch (error) {
            console.log(error)
        }   
    }

    return (
        <Row>
            <Col>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h5 className="text-uppercase colorLabel">{t('consentimiento_telesalud')}</h5>
                        <hr />  
                        <ConsentimientoTeleSalud
                            namePaciente={`${items.cita.patientDTO.name} ${items.cita.patientDTO.middleName} ${items.cita.patientDTO.lastName} ${items.cita.patientDTO.seccondSurname}`}
                            noDocumento={`${items.cita.patientDTO.identityDocumentType.code} ${items.cita.patientDTO.documentNumber ? `: ${items.cita.patientDTO.documentNumber}` : ''}`}
                            nameDoctor={items.cita.scheduleDTO.name_doctor}
                            nameAccount={items.cita.patientDTO.account.name}
                            initialData={{
                                ...items.cita, 
                                identityDocumentTypeModel: items.cita.patientDTO.identityDocumentType,
                                name: items.cita.patientDTO.name,
                                middleName: items.cita.patientDTO.middleName,
                                lastName: items.cita.patientDTO.lastName,
                                seccondSurname: items.cita.patientDTO.seccondSurname,
                                documentNumber: items.cita.patientDTO.documentNumber,
                                doctorName: items.cita.scheduleDTO.name_doctor,
                                nationality: items.cita.speciality.name,
                                especialidadName: items.cita.speciality.name,
                            }}
                            setDataRecord={setContent}
                            extraClass='colorLabel m-0'
                        />
                        <Row>
                            <Col xs="12" md={{span: 8, offset: 2}}>
                                <div className="border">
                                    <SignatureCanvas
                                        penColor='blue'
                                        ref={sigCanvas}
                                        canvasProps={{width: 500, height: 200, border: '1px solid #000'}} 
                                    />
                                    {errors.firma.error && <span className="text-danger">{errors.firma.text}</span>}
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <Form.Check 
                                            className="color-354052 font-size-08rem font-weight-bold-600"
                                            type="checkbox"
                                            label="Aceptación de consentimiento por acudiente"
                                            checked={dataAcudiente.aceptacionAcudiente}
                                            onChange={e=>{
                                                setDataAcudiente(prev=>({
                                                    ...prev,
                                                    aceptacionAcudiente: e.target.checked
                                                }))
                                                if(!e.target.checked){
                                                    setDataAcudiente(prev=>({
                                                        ...prev,
                                                        identityDocumentType: '',
                                                        documentNumber: '',
                                                        patientRelationship: '',
                                                        fullName: ''
                                                    }))
                                                }
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <button className="declined colorLabel" onClick={clear}>Limpiar</button>
                                    </div>                            
                                </div> 

                                {
                                    dataAcudiente.aceptacionAcudiente &&
                                    <Row>
                                        <Col xs="12" md="6">
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary">{t('tipo_documento')} <span className="text-danger">*</span></Form.Label>
                                                <Select
                                                    options={dataAcudiente.tipoDocumentoOpt.map(it=>({label: `${it.code}: ${it.name}`, value: it.id, code: it.code, name: it.name}))}
                                                    value={dataAcudiente.identityDocumentType ? {
                                                        label: `${dataAcudiente.tipoDocumentoOpt.find(it=>it.id === dataAcudiente.identityDocumentType).code}: ${dataAcudiente.tipoDocumentoOpt.find(it=>it.id === dataAcudiente.identityDocumentType).name}`, 
                                                        value: dataAcudiente.identityDocumentType} : null}
                                                    onChange={(value)=>{
                                                        if(value){
                                                            setDataAcudiente(prev=>({
                                                                ...prev, 
                                                                identityDocumentType: value.value,
                                                                hasLength: getLengthDN(value.code)
                                                            }))
                                                            setErrors(prev=>({
                                                                ...prev,
                                                                identityDocumentType: {
                                                                    error: false,
                                                                    text: ''
                                                                }
                                                            }))
                                                        }else{
                                                            setDataAcudiente(prev=>({
                                                                ...prev, 
                                                                identityDocumentType: '',
                                                                hasLength: 10
                                                            }))
                                                            setErrors(prev=>({
                                                                ...prev,
                                                                identityDocumentType: {
                                                                    error: true,
                                                                    text: 'Campo requerido'
                                                                }
                                                            }))
                                                        }                                                        
                                                    }}
                                                    placeholder="Selecciona una opción"
                                                    styles={{
                                                        control: (baseStyles, state) => ({
                                                            ...baseStyles,
                                                            height: '34px',
                                                            border: '1px solid #2A7EC3',
                                                            boxShadow: 0,
                                                            "&:hover": {
                                                                borderColor: '#2A7EC3'
                                                            }
                                                        }),
                                                    }}
                                                />                                                                              
                                                { errors.identityDocumentType.error && <div className="invalid-feedback d-block">{errors.identityDocumentType.text}</div> }
                                            </Form.Group>
                                        </Col>
                                        <Col xs="12" md="6">
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary">{t('documento_identidad')} <span className="text-danger">*</span></Form.Label>
                                                <input 
                                                    type="text"
                                                    className={`form-input ${errors.documentNumber.error && 'error'}`}
                                                    value={dataAcudiente.documentNumber}
                                                    onChange={e=>setDataAcudiente(prev=>({...prev, documentNumber: e.target.value}))}
                                                    onBlur={e=>checkValidationDocument(e.target.value)}

                                                />
                                                { errors.documentNumber.error && <div className="invalid-feedback d-block">{errors.documentNumber.text}</div> }
                                            </Form.Group>
                                        </Col>
                                        <Col xs="12" md="6">
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary">Nombre completo <span className="text-danger">*</span></Form.Label>
                                                <input 
                                                    type="text"
                                                    className={`form-input text-uppercase ${errors.fullName.error && 'error'}`}
                                                    value={dataAcudiente.fullName}
                                                    onChange={e=>{
                                                        setDataAcudiente(prev=>({...prev, fullName: e.target.value.toUpperCase()}))
                                                        if(e.target.value){
                                                            setErrors(prev=>({
                                                                ...prev,
                                                                fullName: {
                                                                    error: false,
                                                                    text: ''
                                                                }
                                                            }))
                                                        }else{
                                                            setErrors(prev=>({
                                                                ...prev,
                                                                fullName: {
                                                                    error: true,
                                                                    text: 'Campo requerido'
                                                                }
                                                            }))
                                                        }
                                                    }} 
                                                />
                                                { errors.fullName.error && <div className="invalid-feedback d-block">{errors.fullName.text}</div> }
                                            </Form.Group>
                                        </Col>
                                        <Col xs="12" md="6">
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary">Parentesco <span className="text-danger">*</span></Form.Label>
                                                <Select
                                                    options={dataAcudiente.tipoPacienteOpt.map(it=>({label: `${it.name}`, value: it.id}))}
                                                    value={dataAcudiente.patientRelationship ? {
                                                        label: dataAcudiente.tipoPacienteOpt.find(it=>it.id === dataAcudiente.patientRelationship).name, 
                                                        value: dataAcudiente.patientRelationship} : null}
                                                    onChange={(value)=>{
                                                        if(value){
                                                            setDataAcudiente(prev=>({
                                                                ...prev, 
                                                                patientRelationship: value.value,
                                                            }))
                                                            setErrors(prev=>({
                                                                ...prev,
                                                                patientRelationship: {
                                                                    error: false,
                                                                    text: ''
                                                                }
                                                            }))
                                                        }else{
                                                            setDataAcudiente(prev=>({
                                                                ...prev, 
                                                                patientRelationship: '',
                                                            }))
                                                            setErrors(prev=>({
                                                                ...prev,
                                                                patientRelationship: {
                                                                    error: true,
                                                                    text: 'Campo requerido'
                                                                }
                                                            }))
                                                        }
                                                        
                                                    }}
                                                    placeholder="Selecciona una opción"
                                                    styles={{
                                                        control: (baseStyles, state) => ({
                                                            ...baseStyles,
                                                            height: '34px',
                                                            border: '1px solid #2A7EC3',
                                                            boxShadow: 0,
                                                            "&:hover": {
                                                                borderColor: '#2A7EC3'
                                                            }
                                                        }),
                                                    }}
                                                /> 
                                            { errors.patientRelationship.error && <div className="invalid-feedback d-block">{errors.patientRelationship.text}</div> }
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                }                            
                            </Col>
                        </Row>

                        <div className="mt-3">
                            <Form.Group className="text-center">
                                <input 
                                    name="aceptarTerminos" 
                                    type="checkbox"  
                                    className="mr-2" 
                                    value={acceptPatient}
                                    onChange={e=>setAcceptPatient(e.target.checked)}
                                />
                                <Form.Label className="fw-medium">{t('acepto')}</Form.Label>
                            </Form.Group>
                        </div>
                        {   items.isProcessRequest ? <div className="text-center"><Loading /></div> :
                            <div className="d-flex justify-content-center">
                                <div className="mr-2">
                                    <button
                                        className="declined"
                                        onClick={() => setItems(prev=>({...prev, openConfirmacionDeclinar: true}))}
                                    >
                                        Declinar
                                    </button>
                                </div>
                                <div>
                                    <button
                                        onClick={() => changeLegalWarning(acceptPatient)}
                                        disabled={!acceptPatient}
                                    >
                                        Aceptar
                                    </button>
                                </div>
                            </div>
                        }
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default withTranslation()(PendiengLegalWarningV2)